/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DynamicFormIntegrationValue { 
    target?: string;
    categoryId?: number;
    formSystemId?: number;
    columnName?: string;
    fixedLookupValue?: string;
    collectionIndex?: number;
    valueSource?: DynamicFormIntegrationValue.ValueSourceEnum;
    displayMetadata?: string;
}
export namespace DynamicFormIntegrationValue {
    export const ValueSourceEnum = {
        SelectedValue: 'SELECTED_VALUE',
        SelectedLabel: 'SELECTED_LABEL'
    } as const;
    export type ValueSourceEnum = typeof ValueSourceEnum[keyof typeof ValueSourceEnum];
}


